module.exports = __webpack_public_path__ + "img/women-feature.c6f78f63.jpg";